var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 76,
    viewBox: "0 0 2 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 76,
    fill: "#E3E3E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Billing",
    clipPath: "url(#clip0_1647_3919)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-719 -298)",
    fill: "#363A3A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 3950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 3736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1319",
    d: "M1 0L0.999997 76",
    stroke: "url(#paint0_linear_1647_3919)",
    strokeWidth: 2
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1647_3919",
    x1: 1.5,
    y1: 2.18557e-8,
    x2: 1.5,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69E4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1647_3919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-719 -298)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.866982b212dc70a4a279a458b7850a23.svg";
export { ForwardRef as ReactComponent };